import { Component, input, output } from '@angular/core';
import {
  QaiButtonComponent,
  QaiCallButtonComponent,
  QaiIconComponent,
} from '@qai/ui';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  imports: [
    MatTooltipModule,
    QaiButtonComponent,
    QaiCallButtonComponent,
    QaiIconComponent,
    TranslocoModule,
  ],
  selector: 'app-call-controls',
  standalone: true,
  styleUrls: ['./call-controls.css'],
  templateUrl: './call-controls.html',
})
export class CallControlsComponent {
  isMicOn = input.required<boolean>();
  isVideoOn = input.required<boolean>();
  isCameraAvailable = input.required<boolean>();
  disableMicButton = input.required<boolean>();
  disableEndCallButton = input.required<boolean>();
  hideCameraToggle = input(false);

  readonly microphoneClicked = output<void>();
  readonly videoClicked = output<void>();
  readonly endCallClicked = output<void>();

  protected handleMicrophoneClick() {
    this.microphoneClicked.emit();
  }

  protected handleVideoClick() {
    this.videoClicked.emit();
  }

  protected handleEndCallClick() {
    this.endCallClicked.emit();
  }
}
